import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from "react-helmet"
import { config } from 'config'
// import * as myBlogFiles from './*'

export default class myBlog extends React.Component {
  _dispLinks(){
    let links = this.props.route.childRoutes.map( (route) => {
      return <div>
        <div>
          <Link to={prefixLink(route.path)}> {route.page.data.title} </Link>
        </div>
      </div>
    });
    return( <div> {links} </div>);
  }
  render () {
    // console.log(" here are my stuff: ", myBlogFiles);
    console.log(" this is the props: ", this.props)
    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
      <h1>Blog pages</h1>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./blog/index.js